/** A signed-in account that is not 240 staff (R18). Nothing here creates a profile. */
export function StaffOnly() {
  return <section className="notice" role="alert">
    <h2>240 Profile is open to 240 staff for now.</h2>
    <p>We are trying it out inside 240 first. When it opens to every 240 Labs teacher, this page will let you build yours.</p>
  </section>;
}
